"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShow = exports.isRender = exports.isReadonly = exports.isPermi = exports.isLoading = exports.isDisabled = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _permission = require("@/utils/permission");
var _store = _interopRequireDefault(require("@/store"));
var _isEmpty = require("./data/is-empty.js");
var _wlUtilsData = require("./wl-utils-data.js");
/** 方法列表
  * isDisabled 是否 禁用
  * isReadonly 是否 只读
  * isLoading 是否 等待
  * isShow 是否 显示
  * isRender 是否 渲染
  * isPermi 是否 有权限
 */

/** 布尔值或方法转换成布尔值
  * @description: 如果是布尔值，那就直接输出布尔值，如果是方法，那就通过方法的返回值转化成布尔值
  * @param { Boolan | Function | Object } value 需要转换的数据
  * @param { String } appoint 是否有指定的目标，如果传入是一个对象，那就找这个对象里的方法
  * @param { Boolean } default 默认
  * @return { Boolean } 返回判断结果
  */
var funToBoolean = function funToBoolean() {
  if (!arguments[0]) return arguments[2];
  var a = arguments[0]; // 需要判断的数据
  var b = arguments[1]; // 判断的字段（前提是 arguments.0 是对象类型）
  var c = arguments[2]; // 默认值
  var d0 = (0, _toConsumableArray2.default)(arguments[3]);
  var d = [].concat((0, _toConsumableArray2.default)(d0.slice(1)), [d0[0]]); // 回调参数
  var v = (0, _typeof2.default)(a) === 'object' ? a : (0, _defineProperty2.default)({}, b, a);
  if (typeof v[b] === 'boolean') return v[b];else if (typeof v[b] === 'function') return Boolean(v[b].apply(v, (0, _toConsumableArray2.default)(d)));else return c;
};

/** 是否 禁用
  * @description: 是否 禁用
  * @param { * } disabled 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isDisabled = exports.isDisabled = function isDisabled(/* disabled */
) {
  return funToBoolean(arguments[0], 'disabled', false, arguments);
};

/** 是否 只读
  * @description: 是否 只读
  * @param { * } readonly 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isReadonly = exports.isReadonly = function isReadonly(/* readonly */
) {
  return funToBoolean(arguments[0], 'readonly', false, arguments);
};

/** 是否 等待
  * @description: 是否 等待
  * @param { * } loading 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isLoading = exports.isLoading = function isLoading(/* loading */
) {
  return funToBoolean(arguments[0], 'loading', false, arguments);
};

/** 是否 有权限
  * @description: 是否 显示
  * @param { * } anyData 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isPermi = exports.isPermi = function isPermi(anyData /* show */) {
  var _store$getters, _anyData$permi;
  if (_store.default !== null && _store.default !== void 0 && (_store$getters = _store.default.getters) !== null && _store$getters !== void 0 && (_store$getters = _store$getters.roles) !== null && _store$getters !== void 0 && _store$getters.includes('admin')) return true;
  var a = (_anyData$permi = anyData.permi) !== null && _anyData$permi !== void 0 ? _anyData$permi : typeof anyData === 'string' ? anyData : '';
  var b = (0, _wlUtilsData.anyInArray)(a);
  // const c = b.filter(s => s !== '' && !s.includes(':'))
  var roles = b.filter(function (s) {
    return s.includes(':');
  });

  // eslint-disable-next-line no-console
  // if (isNoEmpty(c, 'array')) console.warn('无法界定的权限', c, ...arguments)
  if ((0, _isEmpty.isNoEmpty)(roles, 'array')) {
    // 获取权限集
    var permissions = _store.default.getters && _store.default.getters.permissions;
    (0, _permission.hasPermi)(roles);
    return permissions.some(function (role) {
      return roles.includes(role);
    });
  }
  return true;
};

/** 是否 渲染
  * @description: 是否 渲染
  * @param { * } render 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isRender = exports.isRender = function isRender(/* render */
) {
  return funToBoolean(arguments[0], 'render', true, arguments);
};

/** 是否 显示
  * @description: 是否 显示
  * @param { * } show 需要判断的数据，可能是对象，可能是方法
  * @return { Boolean } 返回判断结果
  */
var isShow = exports.isShow = function isShow(/* show */
) {
  return funToBoolean(arguments[0], 'show', true, arguments);
};